<template>
  <div>
    <popup-hint hint="forecast">
      <template v-slot:breadcrumbs>
        <breadcrumbs home="Forecasting">
          <template v-slot:right>
            <v-menu offset-y v-if="$store.getters.company.permissions.includes('forecasting.write')" :close-on-content-click="false" nudge-bottom="5" left>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">mdi-tune-variant</v-icon>
              </template>
              <planning-forecasting-preferences @update="preferences=$event;expanded=[];getPeriod()"/>
            </v-menu>
          </template>
        </breadcrumbs>
      </template>
      <template v-slot:top>
        You can forecast shipments, track to actuals, and identify potential low inventory situations.
      </template>
    </popup-hint>

    <v-list-item>
      <filter-menu include-reset @reset="filters.categoryId=null;filters.search=''">
        <v-list-item>
          <filter-search label="Search products" v-model="filters.search"/>
        </v-list-item>
        <v-list-item>
          <date-picker label="Starting" v-model="filters.dateStart" date-only month-only @change="changeDate()"/>
        </v-list-item>
      </filter-menu>
      <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search=''">Product: {{filters.search}}</v-chip>
      <v-chip v-show="filters.categoryId!=null" close small class="ml-1" @click:close="filters.categoryId=null">{{categoryName}}</v-chip>
      <v-icon @click="back()" class="ml-2">mdi-arrow-left-circle</v-icon>
      <v-icon @click="forward()">mdi-arrow-right-circle</v-icon>
      <v-switch label="Actuals" dense v-model="showActuals" class="ml-4 mt-0" hide-details @change="localStorage.setItem('forecastShowActuals',showActuals)"/>
      <v-switch label="Est. on hand (#)" dense v-model="showOnHand" class="mx-4 mt-0" hide-details @change="localStorage.setItem('forecastShowOnHand',showOnHand)"/>

      <v-menu v-if="estimatedAlerts.length" offset-y nudge-width="900">
        <template v-slot:activator="{on}">
          <v-tooltip bottom open-delay="500" nudge-bottom="10">
            <template v-slot:activator="{on:tooltip}">
              <v-btn icon v-on="{...on,...tooltip}"><v-icon color="warning">mdi-alert</v-icon></v-btn>
            </template>
            Show products with potential low inventory
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title>Potential low inventory</v-card-title>
          <v-card-text>
            <v-simple-table fixed-header height="300">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Period</th>
                  <th class="text-right">Est. start</th>
                  <th class="text-right">+ Actual produced</th>
                  <th class="text-right">+ Sched. produced</th>
                  <th class="text-right">- Forecast/Actual</th>
                  <th class="text-right">= Estimated</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="line in estimatedAlerts">
                  <td>{{line.product}}</td>
                  <td>{{line.title}}</td>
                  <td class="text-right">{{line.previousOnHand | number(0)}}</td>
                  <td class="text-right">
                    {{line.procued | number(0)}}
                  </td>
                  <td class="text-right">
                    {{line.planned | number(0)}}
                    <v-btn small icon :to="{name:'PlanningScheduling',query:{dateStart:line.date+'-01'}}">
                      <v-icon small>mdi-open-in-new</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-right">{{line.reduceBy | number(0)}}</td>
                  <td class="text-right warning--text">{{line.quantity | number(0)}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-menu>

      <v-spacer/>
      <v-btn icon @click="print"><v-icon>mdi-printer</v-icon></v-btn>
<!--
      <v-menu offset-y nudge-width="200" eager>
        <template v-slot:activator="{ on }">
          <v-btn small icon v-on="on" v-on:click.prevent><v-icon>mdi-cog-outline</v-icon></v-btn>
        </template>
        <v-list dense>
          <template v-if="!readOnly">
            <v-list-item @click="showAddProduct=true"><v-list-item-title>Add product</v-list-item-title></v-list-item>
            <v-divider/>
          </template>
          <dense-display v-model="dense" :name="$data._name"/>
        </v-list>
      </v-menu>
      -->
    </v-list-item>

    <v-overlay :value="loading" absolute opacity="0">
      <v-progress-circular indeterminate size="150" color="primary"/>
    </v-overlay>

    <multipane layout="horizontal" @paneResizeStop="resize">

      <v-data-table class="purtrak-table" style="max-height:calc(100vh - 163px);min-height:200px"
          :headers="activeHeaders" fixed-header :items="filteredList" disable-pagination
          hide-default-footer :height="listHeight"
          :show-expand="preferences.byCustomer" single-expand :expanded="expanded">
        <template v-slot:item="{item,isExpanded,expand}">
          <tr @click="selectedId = item.id; updateGraph(item.id); preferences.byCustomer ? expand(!isExpanded) : ''" :class="item.id === selectedId ? 'selected-list-item':''">
            <td class="px-2" v-if="preferences.byCustomer">
              <v-icon>{{isExpanded?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
            </td>
            <td :class="preferences.byCustomer ? 'px-0' :''">
              <div>{{item.name}}</div>
              <v-menu bottom nudge-bottom="20" :close-on-content-click="false" v-if="preferences.byCustomer" v-model="item.addCustomer">
                <template v-slot:activator="{ on:addCustomer }">
                  <v-icon v-on="addCustomer" color="primary" small class="ml-4 d-inline-block" :disabled="unusedCustomers(item).length===0"
                        @click="customerId=unusedCustomers(item)[0].id">
                    mdi-plus-circle
                  </v-icon>
                </template>
                <v-card class="pt-6" width="400">
                  <v-autocomplete v-model="customerId" outlined dense label="Add customer" class="mx-4"
                                  :items="unusedCustomers(item)" item-text="name" item-value="id"/>
                  <v-divider/>
                  <v-card-actions class="pr-4">
                    <v-spacer/>
                    <v-btn plain small @click="item.addCustomer=false">Cancel</v-btn>
                    <v-btn color="primary" small class="ml-4" @click="addCustomer(item);item.addCustomer=false">Add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>

            </td>
            <td>
              <template v-if="showActuals || showOnHand">
                <div class="text-caption">F</div>
                <div class="text-caption" v-if="showActuals">A</div>
                <div class="text-caption" v-if="showOnHand">#</div>
              </template>
            </td>
            <td v-for="period in periods" :key="period.date" class="px-2 text-caption text-right">
              <template v-if="preferences.byCustomer || period.date < currentDate">
                {{productForecast(item, period.date, true)}}
              </template>
              <template v-else>
                <v-menu bottom :close-on-content-click="false" max-width="120"
                        nudge-bottom="20" transition="slide-y-transition">
                  <template v-slot:activator="{on}">
                    <div v-on="on" class="cursor-pointer text-decoration-underline d-inline-block">{{productForecast(item, period.date,true)}}</div>
                  </template>
                  <v-card flat>
                    <decimal-number-input v-model="customerForecast(item.customers[0], period.date).quantity"
                                          :precision="productPrecision(item)" prefix="" :suffix="preferences.productUnits"
                                          :outlined="false" class="text-caption px-4 py-1"
                                          @change="updateDB(item,item.customers[0],customerForecast(item.customers[0], period.date).date)"/>
                  </v-card>
                </v-menu>
              </template>

              <div v-if="showActuals" class="red--text cursor-pointer" :class="{'green--text':productActual(item, period.date, false)>=productForecast(item, period.date, false)}">
                <v-hover v-slot="{hover}" open-delay="1000">
                  <div>
                    {{productActual(item, period.date, true)}}
                    <v-icon v-if="hover" x-small @click="gotoActualDetail(item, period.date)">mdi-open-in-new</v-icon>
                  </div>
                </v-hover>
              </div>

              <v-menu top v-if="showOnHand" min-width="275" open-on-hover nudge-top="20" open-delay="1000">
                <template v-slot:activator="{on}">
                  <div v-on="on"
                      class="red--text cursor-pointer"
                      :class="{'green--text':productEstimated(item, period.date, false) >= 0}">
                    {{productEstimated(item, period.date, true)}}
                  </div>
                </template>
                <v-card flat class="text-caption">
                  <template v-for="details in [productEstimatedDetails(item, period.date)]">
                    <v-container>
                      <v-row no-gutters>
                        <v-col class="font-weight-bold">{{item.name}}</v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col class="font-weight-bold mb-1">{{period.title}}</v-col>
                      </v-row>
                      <v-divider/>
                      <v-row no-gutters>
                        <v-col cols="8">Est. month start</v-col>
                        <v-col cols="4" align="right">{{details.previousOnHand | number(0)}}</v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="8">Produced</v-col>
                        <v-col cols="4" align="right">+ {{details.produced | number(0)}}</v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="8">
                          Sched. production
                          <v-btn x-small icon :to="{name:'PlanningScheduling',query:{dateStart:period.date+'-01'}}">
                            <v-icon x-small>mdi-open-in-new</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="4" align="right">+ {{details.planned | number(0)}}</v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="8">{{details.forecast ? 'Forecast shipping' : 'Actual shipped'}}</v-col>
                        <v-col cols="4" align="right">- {{details.reduceBy | number(0)}}</v-col>
                      </v-row>
                      <v-row no-gutters class="font-weight-bold">
                        <v-col cols="8">= Total estimated</v-col>
                        <v-col cols="4" align="right">{{details.quantity | number(0)}}</v-col>
                      </v-row>
                    </v-container>
                  </template>
                </v-card>
              </v-menu>
            </td>
            <td width="5%" class="text-center px-2">
              <v-menu :nudge-width="220" offset-y :nudge-left="150" v-model="item.menu">
                <template v-slot:activator="{ on:itemMenu }">
                  <v-btn small icon v-on="itemMenu"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list dense>

                  <template v-if="preferences.byCustomer">
                    <v-menu bottom nudge-bottom="30" :close-on-content-click="false">
                      <template v-slot:activator="{ on:addCustomer }">
                        <v-list-item v-on="addCustomer" :disabled="unusedCustomers(item).length===0" @click="expand(true);customerId=unusedCustomers(item)[0].id"><v-list-item-title>Add customer</v-list-item-title></v-list-item>
                      </template>
                      <v-card class="pt-6" width="400">
                        <v-autocomplete v-model="customerId" outlined dense label="Add customer" class="mx-4"
                                        :items="unusedCustomers(item)" item-text="name" item-value="id"/>
                        <v-divider/>
                        <v-card-actions class="pr-4">
                          <v-spacer/>
                          <v-btn plain small @click="item.menu=false">Cancel</v-btn>
                          <v-btn color="primary" small class="ml-4" @click="addCustomer(item)">Add</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </template>

                  <v-menu left :close-on-content-click="false" v-model="item.setForecast">
                    <template v-slot:activator="{ on:setForecast }">
                      <v-list-item v-on="setForecast"
                                  @click="addFrom=0;$set(dateRange,0,activeHeaders[preferences.byCustomer?3:2].value);$set(dateRange,1,activeHeaders[preferences.byCustomer?14:13].value)">
                        <v-list-item-title>Set forecast from previous year</v-list-item-title>
                      </v-list-item>
                    </template>
                    <v-card class="pt-6" width="300">
                      <v-menu :close-on-content-click="false" transition="scale-transition" offset-y v-model="item.dateMenu">
                        <template v-slot:activator="{ on }">
                          <v-text-field label="For dates" dense outlined readonly v-on="on" v-model="dateRangeDisplay" class="ml-4 text-body-2 cursor-pointer"
                                        append-icon="mdi-menu-down" @click:append="item.dateMenu=true" style="width:180px"
                                        :error-messages="dateRange[0] < today ? 'Cannot be before today' : null"/>
                        </template>
                        <v-date-picker v-model="dateRange" no-title range type="month" :allowed-dates="date => date >= currentDate"/>
                      </v-menu>
                      <v-radio-group :column="false" class="mt-0 ml-4 text-caption" v-model="addFrom">
                        <v-radio><template v-slot:label><div class="text-caption">From actuals</div></template></v-radio>
                        <v-radio class="ml-4"><template v-slot:label><div class="text-caption">From forecasts</div></template></v-radio>
                      </v-radio-group>
                      <v-divider/>
                      <v-card-actions class="pr-4">
                        <v-spacer/>
                        <v-btn plain small @click="item.setForecast=false">Cancel</v-btn>
                        <v-btn small color="primary" class="ml-4" :disabled="dateRange[0] < today"
                              @click="setProductForecast(item.id);item.setForecast=false">Set</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>

                  <v-divider/>
<!--
                  <v-list-item @click="graph(item)"><v-list-item-title>Graph forecast vs. actual</v-list-item-title></v-list-item>
                  <v-divider/>
-->
                  <v-menu left :close-on-content-click="false" v-model="item.showDelete">
                    <template v-slot:activator="{ on:onDelete }">
                      <v-list-item v-on="onDelete"><v-list-item-title>Delete forecast</v-list-item-title></v-list-item>
                    </template>
                    <v-card class="pt-6" width="400">
                      <div class="px-4 pb-4">Are you sure you want to delete {{item.name}}?</div>
                      <v-divider/>
                      <v-card-actions class="pr-4">
                        <v-spacer/>
                        <v-btn plain small color="error" class="ml-4" @click="deleteProduct(item);item.menu=false">Delete</v-btn>
                        <v-btn color="primary" small @click="item.showDelete=false;item.menu=false">Cancel</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template v-slot:header.action>
          <v-menu bottom nudge-bottom="45" :close-on-content-click="false" v-model="showAddProduct">
            <template v-slot:activator="{ on }">
              <v-btn fab color="primary" small v-on="on" :loading="loading"
                      @click="addType=0;addForecast=0;productType='';productId='';productsToAdd=[];addFrom=0;$set(dateRange,0,activeHeaders[preferences.byCustomer?3:2].value);$set(dateRange,1,activeHeaders[preferences.byCustomer?14:13].value)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card width="400">
              <outlined-block title="Add" class="pa-4 mb-0">
                <v-radio-group :column="false" class="ml-4 text-caption" v-model="addType"
                                @change="productsToAdd=[];addForecast=addType">
                  <v-radio><template v-slot:label><div class="text-caption">Products</div></template></v-radio>
                  <v-radio class="ml-4"><template v-slot:label><div class="text-caption">None</div></template></v-radio>
                </v-radio-group>
                <v-select label="Products to add" outlined dense multiple class="mx-4" v-model="productsToAdd" v-if="addType!==1"
                          :items="unusedProducts" item-text="name" item-value="id"
                          no-data-text="All products already added">
                  <template v-slot:prepend-item>
                    <v-list-item class="mt-2">
                      <inventory-categories-select label="Filter by category" type="Product" hide-details v-model="categoryId"/>
                    </v-list-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleProductSelect" v-if="unusedProducts.length">
                      <v-list-item-action>
                        <v-icon :color="productsToAdd.length > 0 ? 'blue darken-2' : ''">{{ productAddIcon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content><v-list-item-title>Select All</v-list-item-title></v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"/>
                  </template>
                </v-select>
              </outlined-block>
              <outlined-block title="Set forecast from previous year" class="mx-4">
                <v-radio-group :column="false" class="ml-4 text-caption" v-model="addForecast">
                  <v-radio :disabled="addType===1||!productsToAdd.length"><template v-slot:label><div class="text-caption">Added products</div></template></v-radio>
                  <v-radio class="ml-4"><template v-slot:label><div class="text-caption">All products</div></template></v-radio>
                  <v-radio class="ml-4"><template v-slot:label><div class="text-caption">None</div></template></v-radio>
                </v-radio-group>
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y v-model="dateMenu">
                  <template v-slot:activator="{ on }">
                    <v-text-field label="For dates" dense outlined readonly v-on="on" v-model="dateRangeDisplay" class="ml-4 text-body-2 cursor-pointer"
                                  append-icon="mdi-menu-down" @click:append="dateMenu=true" style="width:180px" :disabled="addForecast===2||(addForecast===0&&!productsToAdd.length)"
                                  :error-messages="dateRange[0] < today ? 'Cannot be before today' : null"/>
                  </template>
                  <v-date-picker v-model="dateRange" no-title range type="month" :allowed-dates="date => date >= currentDate"/>
                </v-menu>
                <v-radio-group :column="false" class="mt-0 ml-4 text-caption" v-model="addFrom"
                              :disabled="addForecast===2||(addForecast===0&&!productsToAdd.length)">
                  <v-radio><template v-slot:label><div class="text-caption">From actuals</div></template></v-radio>
                  <v-radio class="ml-4"><template v-slot:label><div class="text-caption">From forecasts</div></template></v-radio>
                </v-radio-group>
              </outlined-block>

              <v-divider/>
              <v-card-actions class="pr-4">
                <v-spacer/>
                <v-btn plain small @click="showAddProduct=false">Cancel</v-btn>
                <v-btn color="primary" small class="ml-4" @click="addProduct" :loading="loading" :disabled="addForecast!==2 && dateRange[0] < today">Add</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </template>
        <template v-slot:expanded-item="{ item }">
          <tr v-for="customer in item.customers" :key="customer.id" @click="selectedId = item.id; updateGraph(item.id, customer.id)">
            <td class="px-2 grey lighten-4"/>
            <td class="text-caption px-0 grey lighten-4" style="text-indent:20px">{{customer.name}}</td>
            <td class="grey lighten-4">
              <template v-if="showActuals">
                <div class="text-caption">F</div>
                <div class="text-caption">A</div>
              </template>
            </td>
            <td v-for="period in periods" :key="period.date" class="px-2 text-caption text-right grey lighten-4">
              <template v-if="period.date < currentDate">
                {{customerForecast(customer, period.date).quantity | number(productPrecision(item))}}
              </template>
              <template v-else>
                <v-menu bottom :close-on-content-click="false" max-width="120"
                        nudge-bottom="20" transition="slide-y-transition">
                  <template v-slot:activator="{on}">
                    <div v-on="on" class="cursor-pointer text-decoration-underline">{{customerForecast(customer, period.date).quantity | number(productPrecision(item))}}</div>
                  </template>
                  <v-card flat>
                    <decimal-number-input :precision="productPrecision(item)" prefix="" :suffix="preferences.productUnits" :outlined="false" v-model="customerForecast(customer, period.date).quantity" class="text-caption px-4 py-1" @change="updateDB(item,customer,customerForecast(customer, period.date).date)"/>
                  </v-card>
                </v-menu>
              </template>
              <div v-if="showActuals" class="red--text" :class="{'green--text':productActual(item, period.date, false)>=productForecast(item, period.date, false)}"
                    @click="gotoActualDetail(item, period.date)">
                {{customerActual(customer, period.date).quantity | number(productPrecision(item))}}
              </div>
            </td>
            <td width="5%" class="text-center px-2 grey lighten-4">

              <v-menu :nudge-width="220" offset-y :nudge-left="150" v-model="customer.menu">
                <template v-slot:activator="{ on:customerMenu }">
                  <v-btn small icon v-on="customerMenu"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list dense>

                  <v-menu left :close-on-content-click="false" v-model="customer.setForecast">
                    <template v-slot:activator="{ on:setForecast }">
                      <v-list-item v-on="setForecast"
                                  @click="addFrom=0;$set(dateRange,0,activeHeaders[preferences.byCustomer?3:2].value);$set(dateRange,1,activeHeaders[preferences.byCustomer?14:13].value)">
                        <v-list-item-title>Set forecast from previous year</v-list-item-title>
                      </v-list-item>
                    </template>
                    <v-card class="pt-6" width="300">
                      <v-menu :close-on-content-click="false" transition="scale-transition" offset-y v-model="item.dateMenu">
                        <template v-slot:activator="{ on }">
                          <v-text-field label="For dates" dense outlined readonly v-on="on" v-model="dateRangeDisplay" class="ml-4 text-body-2 cursor-pointer"
                                        append-icon="mdi-menu-down" @click:append="item.dateMenu=true" style="width:180px"
                                        :error-messages="dateRange[0] < today ? 'Cannot be before today' : null"/>
                        </template>
                        <v-date-picker v-model="dateRange" no-title range type="month" :allowed-dates="date => date >= currentDate"/>
                      </v-menu>
                      <v-radio-group :column="false" class="mt-0 ml-4 text-caption" v-model="addFrom">
                        <v-radio><template v-slot:label><div class="text-caption">From actuals</div></template></v-radio>
                        <v-radio class="ml-4"><template v-slot:label><div class="text-caption">From forecasts</div></template></v-radio>
                      </v-radio-group>
                      <v-divider/>
                      <v-card-actions class="pr-4">
                        <v-spacer/>
                        <v-btn plain small @click="customer.setForecast=false">Cancel</v-btn>
                        <v-btn small color="primary" class="ml-4" :disabled="dateRange[0] < today"
                              @click="setProductForecast(item.id, customer.id);customer.setForecast=false">Set</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
<!--
                  <v-divider/>
                  <v-list-item @click="graph(item, customer)"><v-list-item-title>Graph forecast vs. actual</v-list-item-title></v-list-item>
-->
                  <template v-if="customer.id!==''">
                    <v-divider/>
                    <v-menu left :close-on-content-click="false" v-model="customer.showDelete">
                      <template v-slot:activator="{ on:customerDelete }">
                        <v-list-item v-on="customerDelete">
                          <v-list-item-title>Delete customer</v-list-item-title>
                        </v-list-item>
                      </template>
                      <v-card class="pt-6" width="400">
                        <div class="px-4 pb-4">Are you sure you want to delete {{customer.name}}?</div>
                        <v-divider/>
                        <v-card-actions class="pr-4">
                          <v-spacer/>
                          <v-btn plain small color="error" class="ml-4" @click="deleteCustomer(item, customer)">Delete</v-btn>
                          <v-btn color="primary" small @click="customer.showDelete=false">Cancel</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </template>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>

      <multipane-resizer/>

      <v-card flat tile :height="chartHeight">
<!--
        <v-btn icon small style="float:right;right:10px;top:10px;z-index:1" @click="printGraph" v-show="!!graphItemId"><v-icon>mdi-printer</v-icon></v-btn>
-->
        <div ref="chart" :style="'height:'+innerChartHeight">
        </div>
      </v-card>
    </multipane>

    <component :is="forecastGraph" :product="graphProduct" :customer="graphCustomer" :productUnits="graphUnits" :periods="periods" @close="forecastGraph=null"/>
    <component :is="forecastPrint" :list="filteredList" :periods="periods" :preferences="preferences" :showActuals="showActuals" :showOnHand="showOnHand"
               @close="forecastPrint = null"/>

  </div>
</template>

<style scoped>
.multipane .multipane-resizer {
  margin: 0; top: 0; /* reset default styling */
  height: 5px;
  background: #eee;
  border-top:1px solid #ccc;
  border-bottom:1px solid #ccc;
}
</style>

<script>
import googleCharts from '@/mixins/googleCharts'
import {format, add, parse, lastDayOfMonth} from 'date-fns'
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'
import PlanningForecastingPreferences from '@/views/planning/forecasting/PlanningForecastingPreferences'
import { Multipane, MultipaneResizer } from 'vue-multipane'

export default {
  components: { InventoryCategoriesSelect,PlanningForecastingPreferences,Multipane,MultipaneResizer},
  name: 'PlanningForecasting',
  mixins: [googleCharts],
  data() {
    return {
      loading: true,
      selectedId: null,
      listHeight: '200px',
      chartHeight: '',
      innerChartHeight: '',
      chart: null,
      graphItemId: null,
      graphCustomerId: null,
      preferences: {},
      filters: {
        type: '',
        dateStart: '',
        dateEnd: '',
        search: '',
        categoryId: null
      },
      categoryName: '',
      today: format(new Date(), 'yyyy-MM'),
      currentDate: format(new Date(), 'yyyy-MM'),
      localStorage: window.localStorage,
      showActuals: localStorage.getItem('forecastShowActuals') === 'true',
      showOnHand: localStorage.getItem('forecastShowOnHand') === 'true',
//      period: 'monthly', // quarterly, semi-annually, annually
      products: [],
      expanded: [],
      allProducts: [],

      showAddProduct: false,
      addType: 0,
      productsToAdd: [],
      addForecast: 0,
      addFrom: 0,
      categoryId: '',
      dateRange: ['2021-12','2022-12'],
      dateMenu: false,

      customers: [],
      customerId: '',
      showDeleteProduct: false,
      forecastGraph: null,
      graphProduct: null,
      graphCustomer: null,
      graphUnits: '',
      forecastPrint: null
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('forecasting.write');
    },
    dateRangeDisplay() {
      return `${format(new Date(this.dateRange[0]+'-01 00:00:00'), 'MMM yy')} to ${format(new Date(this.dateRange[1]+'-1 00:00:00'), 'MMM yy')}`;
    },
    productAddIcon() {
      if (this.productsToAdd.length === this.unusedProducts.length)
        return 'mdi-checkbox-marked'
      if (this.productsToAdd.length)
        return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    periods() {
      const periods = [];
      const refDate = new Date();
      let period = parse(this.filters.dateStart+'-01', 'yyyy-MM-dd', refDate);
      const end = parse(this.filters.dateEnd+'-01', 'yyyy-MM-dd', refDate);
      while (period.getTime() <= end.getTime()) {
        periods.push({date:format(period, 'yyyy-MM'),title:format(period, "MMM yy")});
        period = add(period, {months: 1});
      }
      return periods;
    },
    unusedProducts() {
      return this.allProducts.filter(product =>
        !this.products.some(p => p.id === product.id) && (!this.categoryId || product.category?.id === this.categoryId)
      );
    },
    filteredList() {
      const searchFor = this.filters.search?.toLowerCase();
      return this.products.filter(product => {
        if (searchFor && !product.name.toLowerCase().includes(searchFor))
          return false;

        if (this.filters.categoryId && product.category?.id !== this.filters.categoryId)
          return false;

        return true;
      });
    },
    activeHeaders() {
      const headers = [
              {text: `PRODUCT${this.preferences.byCustomer?`/CUSTOMER`:``} ${this.preferences.productUnits}`, value: 'name', width:'20%',sortable:true,class:this.preferences.byCustomer?'px-0':''},
              {text:'',value:'',width:'1%',sortable:false},
              ...(() => {
                const columns = [];
                this.periods.forEach(period => {
                  columns.push({text:period.title, value:period.date, sortable:false,class:'px-2',align:'right'});
                });
                return columns;
              })(),
              {text: '' , value:'action', width:'1%',sortable:false,align:'center',print:false,class:'px-2'}
             ];
      if (this.preferences.byCustomer)
        headers.splice(0, 0, {text: '', value: 'data-table-expand', width:'1%',sortable:false,print:false,class:'px-2'});
      return headers;
    },
    estimatedAlerts() {
      const list = [];
      this.filteredList.forEach(product => {
        this.periods.forEach(period => {
          if (this.productEstimated(product, period.date, false) < 0) {
            const details = this.productEstimatedDetails(product, period.date);
            list.push({product:product.name,...period,...details})
          }
        });
      });
      return list;
    }
  },
  async created() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$store.commit('setError', {type:'warning',message:`We're sorry, but forecasting is not available on mobile devices`});
      this.$router.back();
      return;
    }

    const data = await Promise.all([
      this.$store.dispatch('customers'),
      this.$lazyListLoad(this.allProducts, 'products2', 'id,name,category{id},caseSize,bottleSize,strength,palletHI,palletTI', 100, [{field:'active', comparator:'eq', value:'true'}]),
    ]);
    this.customers = data[0];

    const results = await this.$apiCall(`query PlanningForecasting {
                                           forecastPreferences {
                                             byCustomer,productUnits
                                           }
                                          }`,
                                          {});
    if (!results.error) {
      this.preferences = results.data.forecastPreferences;
      this.filters.dateStart = localStorage.getItem('forecastStart') || format(new Date(), 'yyyy-MM');
      this.changeDate();
    }
  },
  async mounted() {
    await this.loadGoogleCharts();
    window.google.charts.load('current', {'packages':['corechart']});
    window.google.charts.setOnLoadCallback(() => {
      if (this.$refs.chart == undefined)
        return;
      this.chart = new window.google.visualization.ComboChart(this.$refs.chart);
    });
    this.resize(null, null, '300px');
  },
  methods: {
    gotoActualDetail(product, date) {
      const fromDate = `${date}-01`;
      const toDate = format(lastDayOfMonth(new Date(`${fromDate} 00:00:00`)), 'yyyy-MM-dd');
      const units = this.preferences.productUnits.toLowerCase();
      this.$router.push({name:'ReportsView',
                         params:{back:[{text:'Forecasting',to:{name:'PlanningForecasting'}}]},
                         query:{to:'reports/sales/ReportsSalesDetailsByCustomer', fromDate, toDate, id:product.id, type:product.type, units}});

    },
    toggleProductSelect() {
      this.$nextTick(() => {
        if (this.productsToAdd.length === this.unusedProducts.length)
          this.productsToAdd = []
        else
          this.productsToAdd = this.unusedProducts.map(product => product.id);
      })
    },
    productPrecision(product) {
      return 0;
//      return product.type !== 'Product' || this.preferences.productUnits === 'LAA' || this.preferences.productUnits === 'Litres' ? 3 : 0;
    },
    changeDate() {
      localStorage.setItem('forecastStart', this.filters.dateStart);
      this.filters.dateEnd = format(add(new Date(`${this.filters.dateStart}T00:00:00`), {months:11}), 'yyyy-MM');
      this.getPeriod();
    },
    back() {
      this.filters.dateStart = format(add(new Date(`${this.filters.dateStart}T00:00:00`), {months:-1}), 'yyyy-MM');
      this.changeDate();
    },
    forward() {
      this.filters.dateStart = format(add(new Date(`${this.filters.dateStart}T00:00:00`), {months:1}), 'yyyy-MM');
      this.changeDate();
    },
    async getPeriod() {
      this.loading = true;
      const results = await this.$apiCall(`query PlanningForecasting($from:String!, $to:String!) {
                                              forecastProducts(from:$from,to:$to) {
                                                id,type,name,category{id},initialOnHand
                                                customers {id,name,forecast {date,quantity}, actuals {date,quantity}}
                                                planned {date,quantity}
                                                produced {date,quantity}
                                              }
                                            }`,
                                            {from:this.filters.dateStart, to:this.filters.dateEnd});
      if (!results.error) {
        this.products = results.data.forecastProducts.map(product => ({...product, forecast:[], actuals:[], onHand:[]}));
        this.products.forEach(product => {

          // Change quantity to display type
          if (product.type === 'Product' && this.preferences.productUnits !== 'Bottles') {
            const productObject = this.allProducts.find(p => p.id === product.id);
            product.customers.forEach(customer => {
              customer.forecast.forEach(forecast => {
                forecast.quantity = this.quantityFromBottles(productObject, forecast.quantity);
              })
              customer.actuals.forEach(actual => {
                actual.quantity = this.quantityFromBottles(productObject, actual.quantity);
              })
            })
          }

          this.periods.forEach(period => {
             this.update(product, period.date);
          })

          this.updateOnHand(product);
        });
        if (!this.graphItemId) {
          this.selectedId = this.products[0]?.id;
          this.graphItemId = this.selectedId;
        }
        this.refreshGraph();
      }
      this.loading = false;
    },
    quantityFromBottles(productObject, quantity) {
      if (this.preferences.productUnits === 'Cases')
        return this.$roundNumber(quantity / productObject.caseSize, 0);
      if (this.preferences.productUnits === 'Pallets')
        return this.$roundNumber(quantity / productObject.caseSize / (productObject.palletHI * productObject.palletTI), 0);
      if (this.preferences.productUnits === 'LAA')
        return this.$roundNumber(quantity * (productObject.bottleSize/1000) * (productObject.strength/100), 3);
      if (this.preferences.productUnits === 'Litres')
        return this.$roundNumber(quantity * (productObject.bottleSize/1000), 3);
      return quantity;
    },
    unusedCustomers(product) {
      return this.customers.filter(customer => !product.customers.some(c => c.id === customer.id));
    },
    productForecast(product, date, formatted) {
      const quantity = product.forecast.find(forecast => forecast.date === date)?.quantity ?? 0;
      return formatted ? this.$number(quantity, this.productPrecision(product)) : quantity;
    },
    productActual(product, date, formatted) {
      const quantity = product.actuals.find(actual => actual.date === date)?.quantity ?? 0;
      return formatted ? this.$number(quantity, this.productPrecision(product)) : quantity;
    },
    productEstimated(product, date, formatted) {
      const quantity = product.onHand.find(onHand => onHand.date === date)?.quantity ?? 0;
      return formatted ? this.$number(quantity, this.productPrecision(product)) : quantity;
    },
    productEstimatedDetails(product, date) {
      return product.onHand.find(onHand => onHand.date === date) ?? {};
    },
    customerForecast(customer, date) {
      return customer.forecast.find(forecast => forecast.date === date) ?? {quantity:0};
    },
    customerActual(customer, date) {
      return customer.actuals?.find(actual => actual.date === date) ?? {quantity:0};
    },
    async addProduct() {
      this.loading = true;
      let forecastProducts;
      if (this.addType !== 1 && this.productsToAdd.length) {
        const results = await this.$apiCall(`mutation PlanningForecasting($products:[ID]!) {
                                              forecastProductsAdd(products:$products) {id,name}
                                            }`, {products:this.productsToAdd})
        if (!results.error)
          forecastProducts = results.data.forecastProductsAdd;
      }

      if (this.addForecast === 0 && forecastProducts.length ||
          this.addForecast === 1 && this.products.length) {
        const products = this.addForecast === 0 ? forecastProducts.map(product => product.id) : undefined;
        await this.$apiCall(`mutation PlanningForecasting($input:ForecastSetInput!) {
                                forecastSet(input:$input) {id,name}
                              }`, {input:{products,from:this.dateRange[0],to:this.dateRange[1],actuals:this.addFrom===0}})
      }

      this.getPeriod();
      this.showAddProduct = false;
      this.loading = false;
    },
    async setProductForecast(product, customerId) {
      this.loading = true;
      await this.$apiCall(`mutation PlanningForecasting($input:ForecastSetInput!) {
                              forecastSet(input:$input) {id,name}
                            }`, {input:{products:[product],customerId,from:this.dateRange[0],to:this.dateRange[1],actuals:this.addFrom===0}})
      this.getPeriod();
      this.loading = false;
    },
    async deleteProduct(product) {
      const results = await this.$apiCall(`mutation PlanningForecasting($id:ID!) {
                                             forecastProductDelete(id:$id) {id}
                                           }`, {id:product.id})
      if (!results.error) {
        const index = this.products.findIndex(p => p.id === product.id);
        this.products.splice(index, 1);
        product.showDelete = false;
      }
    },
    async addCustomer(product) {
      const customer = this.unusedCustomers(product).find(c => c.id === this.customerId);
      const results = await this.$apiCall(`mutation PlanningForecasting($productId:ID!,$customerId:ID!) {
                                             forecastCustomerAdd(productId:$productId, customerId:$customerId) {id}
                                           }`, {productId:product.id,customerId:customer.id})
      if (!results.error) {
        const forecastCustomer = {id:customer.id,name:customer.name,forecast:[]};
        this.periods.forEach(period => {
          forecastCustomer.forecast.push({date:period.date,quantity:0});
        })
        product.customers.push(forecastCustomer);
        product.menu = false;
      }
    },
    async deleteCustomer(product, customer) {
      const results = await this.$apiCall(`mutation PlanningForecasting($productId:ID!,$customerId:ID!) {
                                             forecastCustomerDelete(productId:$productId, customerId:$customerId) {id}
                                           }`, {productId:product.id,customerId:customer.id})
      if (!results.error) {
        this.getPeriod();
      }
    },
    async updateDB(product, customer, date) {
      let quantity = customer.forecast.find(f => f.date === date).quantity;
      if (quantity >= 0) {
        if (product.type === 'Product' && this.preferences.productUnits !== 'Bottles') {   // Convert quantity to bottles
          const productObject = this.allProducts.find(p => p.id === product.id);
          if (this.preferences.productUnits === 'Cases')
            quantity *= productObject.caseSize;
          else if (this.preferences.productUnits === 'Pallets')
            quantity *= productObject.caseSize * productObject.palletHI * productObject.palletTI;
          else if (this.preferences.productUnits === 'Litres')
            quantity = this.$roundNumber(quantity / (productObject.bottleSize/1000), 0);
          else    // LAA
            quantity = this.$roundNumber(quantity / (productObject.strength/100) / (productObject.bottleSize/1000), 0);
        }
        const results = await this.$apiCall(`mutation PlanningForecasting($input:ForecastInput!) {
                                              forecastUpdate(input:$input) {id}
                                            }`,
                                            {input:{productId:product.id,customerId:customer.id,date,quantity}})
        if (!results.error) {
          this.update(product, date);
          this.updateOnHand(product);
          this.refreshGraph();
          return;
        }
      }
      this.getPeriod();
    },
    update(product, date) {
      const forecastIndex = product.forecast.findIndex(forecast => forecast.date === date);

      // Find customer total for quantity for date
      const quantity = product.customers.reduce((quantity, customer) => {
        const forecast = customer.forecast.find(forecast => forecast.date === date);
        if (!forecast) {    // Sorta a side effect, which is only being done here for efficiency
          const index = customer.forecast.findIndex(forecast => forecast.date > date);
          if (index !== -1)
            customer.forecast.splice(index, 0, {date, quantity:0});
          else
            customer.forecast.push({date, quantity:0});
        }
        return quantity + (forecast ? forecast.quantity : 0);
      }, 0);

      // If forecasted quantity, add to product if not there, otherwise replace
      const forecast = {date, quantity};
      forecastIndex === -1 ? product.forecast.push(forecast) : this.$set(product.forecast, forecastIndex, forecast); // product.forecast[forecastIndex] = forecast;

      const actualIndex = product.actuals.findIndex(actual => actual.date === date);

      // Find customer total for quantity for date
      const actualQuantity = product.customers.reduce((quantity, customer) => {
        const actual = customer.actuals.find(actual => actual.date === date);
        if (!actual) {    // Sorta a side effect, which is only being done here for efficiency
          const index = customer.actuals.findIndex(actual => forecast.date > date);
          if (index !== -1)
            customer.actuals.splice(index, 0, {date, quantity:0});
          else
            customer.actuals.push({date, quantity:0});
        }
        return quantity + (actual ? actual.quantity : 0);
      }, 0);

      // If forecasted quantity, add to product if not there, otherwise replace
      const actual = {date, quantity:actualQuantity};
      actualIndex === -1 ? product.actuals.push(actual) : this.$set(product.actuals, actualIndex, actual); // product.actuals[actualIndex] = actual;
    },
    updateOnHand(product) {
      const productObject = this.allProducts.find(p => p.id === product.id);

      product.onHand = [];
      let previousOnHand = product.type === 'Product' ? this.quantityFromBottles(productObject, product.initialOnHand) : product.initialOnHand;
      this.periods.forEach(period => {
        const plannedQuantity = product.planned.find(planned => planned.date === period.date)?.quantity ?? 0;
        const planned = product.type === 'Product' ? this.quantityFromBottles(productObject, plannedQuantity) : plannedQuantity;
        const producedQuantity = product.produced.find(produced => produced.date === period.date)?.quantity ?? 0;
        const produced = product.type === 'Product' ? this.quantityFromBottles(productObject, producedQuantity) : producedQuantity;
        const forecast = this.productForecast(product, period.date, false);
        const actual = this.productActual(product, period.date, false);
        const reduceBy = Math.max(forecast, actual);
        const newOnHand = previousOnHand + produced + planned - reduceBy;
        product.onHand.push({date:period.date, quantity:newOnHand, previousOnHand, produced, planned, reduceBy, forecast:forecast > actual});
        previousOnHand = newOnHand;
      })
    },

/*
    async graph(product, customer) {
      this.graphProduct = product;
      this.graphCustomer = customer;
      this.graphUnits = this.productUnits(product);
      this.forecastGraph = () => import('@/views/planning/forecasting/PlanningForecastingGraph');
    },
  */
    async print() {
      this.forecastPrint = () => import('@/views/planning/forecasting/PlanningForecastingPrint');
    },

    resize(pane, container, size) {
      this.listHeight = size;
      this.chartHeight = `calc(100vh - ${size} - 158px)`;
      this.innerChartHeight = `calc(100vh - ${size} - 168px)`;
      this.$nextTick(() => this.refreshGraph());
    },
    updateGraph(itemId, customerId) {
      this.graphItemId = itemId;
      this.graphCustomerId = customerId;
      this.refreshGraph();
    },
    refreshGraph() {
      if (!this.graphItemId)
        return;
      const graphItem = this.filteredList.find(item => item.id === this.graphItemId);
      const graphCustomer = this.graphItem?.customers.find(customer => customer.id === this.graphCustomerId);
      const graphData = [['Month','Forecast','Actual']];
      const forecast = graphCustomer ? graphCustomer.forecast : graphItem.forecast;
      const actuals = graphCustomer ? graphCustomer.actuals : graphItem.actuals;
      for (const period of this.periods)
        graphData.push([period.title,
                             forecast.find(forecast => forecast.date === period.date)?.quantity || 0,
                             actuals.find(actual => actual.date === period.date)?.quantity || 0
                            ]);

      const options = {
        fontSize:10,
        chartArea:{height:'80%',width:'90%',left:75,top:35},
        legend: {position: 'top'},
        vAxis: {title: this.productUnits, minValue:0, format:'#,###'},
        seriesType: 'bars',
        series: {1: {type: 'line'}}
      };
      this.chart?.draw(google.visualization.arrayToDataTable(graphData), options);
    },
/*
    printGraph() {
      this.printHtml('',`<style>
                        @page {size:landscape}
                        body {font-family: Roboto, sans-serif; font-size:14px}
                        .title {font-weight:700;font-size:18px;text-align:center;width:100%}
                        .sub-title {text-align:center;margin-bottom:16px,width:100%}
                      </style>
                      <img id="graph"/>`,
                      {id:'graph', src:this.chart.getImageURI()});
    }
  */
  }
}
</script>